import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const SearchIcon = (props: SvgIconProps) => (
  <SearchOutlinedIcon {...props} fontSize="small" />
);

export default SearchIcon;
